import * as cheerio from 'cheerio';

import { Observable, Subject } from 'rxjs';
import { AiService } from '../../services/ai.service';
import Quill from 'quill';
import { QuillModules } from 'ngx-quill';
import { quillConfig } from './quill.config';
import { Delta } from 'quill/core';

export type AIStatusType = 'none' | 'loading' | 'done' | 'finalizing' | 'error';
export default class RichEditorUtil {
  preventEditorSave: boolean = false;

  aiTimerConfig: any = {};

  aiGeneratedContent = '';

  isInitialized = false;
  isEditorReady = false;
  isInitialValueSet: boolean = false;

  editor: Quill;
  editorID: string;
  muteChangeEmit: boolean;
  //   parser: edjsParser = new edjsParser();
  content: string = '';

  lastEmitContent: string = '';

  debonucing: boolean = false;

  config: QuillModules = quillConfig;

  // UI Values
  placeholder: string = 'Your story begins here...';

  //   Events Management
  private changeSubject = new Subject<string>();
  private readySubject = new Subject<void>();

  onChange$: Observable<string> = this.changeSubject.asObservable();
  onReady$: Observable<void> = this.readySubject.asObservable();

  //   Ai Related
  promptFunction?: (...args) => string;
  aiStatus: AIStatusType = 'none';
  //   onChange: (HTMLContent: string) => void = (HTMLContent: string) => {};
  //   onReady: () => void = () => {};

  constructor(
    initialConfiguration: {
      content?: string;
      editorID?: string;
      config?: QuillModules;
      placeholder?: string;
      promptFunction?: (...args) => string;
    },
    private ai?: AiService
  ) {
    Object.assign(this, initialConfiguration);
    this.initializeEditor();
  }

  initializeEditor(editorID = this.editorID) {
    this.isInitialized = true;
    console.log('Initializing EditorID', editorID);
    const container = document.getElementById(`${editorID}`);
    this.editor = new Quill(container, {
      modules: this.config,
      theme: 'snow',
      placeholder: this.placeholder,
    });

    this.editor.on(
      'text-change',
      (delta: Delta, oldContents: Delta, source: string) => {
        // console.log(delta.ops.length && delta.ops.some(op => !!op?.insert));
        const isRealEvent =
          delta.ops.length &&
          delta.ops.some(
            (op) => !!op?.insert || !!op.delete || !!op.attributes
          );
        console.log(isRealEvent);
        // const isRealEventArray = event instanceof Array && (event as CustomEvent[])?.some(event => event.type == 'block-changed' || event.type == 'block-removed');
        if (isRealEvent) {
          if (!this.preventEditorSave) {
            this.onChange();
          }
        }
      }
    );
  }

  clearEditor() {
    this.editor.setContents([{ insert: '\n' }]);
    this.content = '';
    this.resetAiState();
  }

  public setHTMLContent(value: string) {
    this.editor.setText(value);
    // return this.editor.blocks.renderFromHTML(value).finally(() => {
    if (this.aiStatus === 'finalizing' || this.aiStatus === 'done') {
      this.scrollToEditorEnd();
    }
    // });
  }

  setAiStatus(status: AIStatusType) {
    this.aiStatus = status;
    switch (status) {
      case 'done':
        setTimeout(() => {
          this.scrollToEditorEnd();
          setTimeout(() => {
            this.setAiStatus('none');
          }, 2000);
        }, 100);

        break;

      default:
        break;
    }
  }

  scrollToEditorEnd() {
    const editorElement = document.getElementById(`${this.editorID}`);
    const writingElement = document.getElementById(`${this.editorID}_writing`);

    editorElement ? console.log('scrolling editor') : console.log('no editor');
    writingElement
      ? console.log('scrolling writing')
      : console.log('no writing');

    editorElement?.scrollBy({
      top: editorElement.scrollHeight,
      behavior: 'instant' as ScrollBehavior,
    });
    writingElement?.scrollBy({
      top: writingElement.scrollHeight,
      behavior: 'instant' as ScrollBehavior,
    });
  }
  //   public setAiGeneratedToEditor() {
  //     this.setHTMLToEditor(this.aiGeneratedContent, { emitValue: false });
  //     this.aiGeneratedContent = ''
  //   }

  setEditorHtmlContent(content: string) {
      this.editor.clipboard.dangerouslyPasteHTML(0, content);
  }
  public onChange(content = this.editor.getSemanticHTML()) {
    
    content = this.optimizeHTMLContent(content);
    this.content = content;
    if (!this.muteChangeEmit) {
      this.lastEmitContent = content;
      this.changeSubject.next(content);
      //   this.onChange(HTMLContent);
    } else {
      this.muteChangeEmit = false;
    }
  }

  //   Util Functions
  public optimizeHTMLContent = (content: string) => {
    if (!content) return '';
    const $ = cheerio.load(content);

    $('img, iframe').remove();

    const body = $('body');

    body.contents().each((index, element) => {
      const elementHTML = $(element);
      const text = elementHTML.text().trim();

      let matchedPattern: string | null | RegExp = null;
      let listType = 'ul';

      if (text.includes('- ')) {
        matchedPattern = '- ';
        listType = 'ul';
      } else if (text.includes('* ')) {
        matchedPattern = '* ';
        listType = 'ul';
      } else if (text.match(/^\d+\.\s/gm)) {
        matchedPattern = /^\d+\.\s/gm;
        listType = 'ol';
      }

      if (matchedPattern) {
        const items = text
          .split(matchedPattern)
          .map((item) => item.trim())
          .filter((item) => item.length > 0);

        const firstItemHasHyphen = items[0].startsWith(
          matchedPattern.toString()
        );
        const firstTitle = firstItemHasHyphen ? '' : items[0];
        const filteredItems = firstItemHasHyphen ? items : items.slice(1);

        if (filteredItems.length < 2) return;

        const listItems = filteredItems
          .map((item) => `<li>${item}</li>`)
          .join('');
        const listElement = `<${listType}>${listItems}</${listType}>`;

        elementHTML.replaceWith(`<div>${firstTitle}${listElement}</div>`);
      }
    });

    $('li').each((index, element) => {
      const $li = $(element);
      if (
        $li.parent().prop('tagName').toLowerCase() !== 'ul' &&
        $li.parent().prop('tagName').toLowerCase() !== 'ol'
      ) {
        const $ul = $('<ul>');
        $li.nextUntil('li').addBack().appendTo($ul);
        $ul.insertAfter($li.prevAll('li').last());
      }
    });

    const bodyContent = $('body').html();

    return bodyContent;
  };

  static generateUniqueID(): string {
    const randomString = Math.random().toString(36).substring(2, 8);
    const timestamp = new Date().getTime();
    return `editor-${randomString}${timestamp}`;
  }

  // Ai Based Features

  startGenerating = async (promptFunction = this.promptFunction) => {
    let data: {
      completions: string;
    } = {
      completions: '',
    };
    const prompt = !!promptFunction ? promptFunction() : undefined;  
    if (!prompt?.length) {
        return new Promise((resolve, reject) => reject(true));
    }
    

    let lastChar: string = null;
    this.setAiStatus('loading');
    this.startTimer();
    this.clearEditor();
    return new Promise((resolve) => {
      this.ai.getCompletion(prompt, true, true).subscribe({
        next: (response: string) => {
          //

          this.aiGeneratedContent += response;
          this.scrollToEditorEnd();
          if (response !== '\n' && !this.aiGeneratedContent.length) {
            this.clearEditor();
          }

          lastChar = data.completions;
        },
        error: (error) => {
          this.setAiStatus('error');
          this.clearTimer();
        },
        complete: () => {
          this.stopTimer();
          this.setAiStatus('finalizing');

          // this.editorController.aiGeneratedContent =
          //   this.editorController.optimizeHTMLContent(
          //     this.editorController.aiGeneratedContent
          //   );

          this.setEditorHtmlContent(this.aiGeneratedContent);
          setTimeout(() => {
            this.setAiStatus('done');
            this.resetAiState();
            resolve(true);
          }, 1500);
        },
      });
    });
  };

  resetAiState() {
    this.aiGeneratedContent = '';
  }

  // Timer Functions

  startTimer(): void {
    this.aiTimerConfig.startTime = new Date().getTime();

    this.aiTimerConfig.timerId = setInterval(() => {
      const currentTime = new Date().getTime();
      this.aiTimerConfig.elapsedTime =
        currentTime - this.aiTimerConfig.startTime;
    }, 100);
  }

  clearTimer() {
    this.stopTimer();
    this.aiTimerConfig.elapsedTime = null;
  }

  stopTimer() {
    clearInterval(this.aiTimerConfig.timerId);
  }

  resetTimer() {
    this.aiTimerConfig.elapsedTime = 0;
  }
}
